import React, {PropsWithChildren} from 'react';
import {useTranslation} from 'react-i18next';
import {TextInputReport} from '../../../../incase-domain/analytics';
import SkeletonLoader from '../../../components/common/SkeletonLoader';

interface TextInputsReportProps {
    textInputs: TextInputReport[];
    isLoading: boolean;
}

function TextInputsReport({textInputs, isLoading}: PropsWithChildren<TextInputsReportProps>): JSX.Element {
    const {t} = useTranslation();

    return (
        <SkeletonLoader isLoading={isLoading} props={{style: {minHeight: '30rem'}}}>
            <div className="avoid">
                <div className="p-presReport__card_title">{t('reportPage.textInputs.title')}</div>
                <div className="p-presReport__card">
                    <div className="c-textInputsReport">
                        {textInputs?.map((inputReport) => (
                            <div className="c-textInputsReport__input avoid" key={inputReport.elementId}>
                                <div className="c-textInputsReport__input_label">{inputReport.label}</div>
                                {inputReport.answers.length ? (
                                    <ol className="c-textInputsReport__input_answers">
                                        {inputReport.answers.map((answer, index) => (
                                            <li key={index}>{answer}</li>
                                        ))}
                                    </ol>
                                ) : (
                                    <div className="c-textInputsReport__input_noAnswers">{t('reportPage.textInputs.noAnswers')}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </SkeletonLoader>
    );
}

export default TextInputsReport;
